import React from 'react'
import {
    SectionHeader,
    SectionHeaderProps,
} from '../../section-header/SectionHeader/SectionHeader'
import { createRegisterableComponent } from '@news-mono/web-common'

export interface SectionHeaderRouteProps extends SectionHeaderProps {}

export const SectionHeaderRegistration = createRegisterableComponent(
    'section-header',
    (props: SectionHeaderRouteProps) => <SectionHeader {...props} />,
)
